import { z } from "zod";

export const regionSchema = z.object({
	id: z.string().optional(),
	name: z.string().nullable().optional(),
	code: z.string().nullable().optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
});

export type Region = z.infer<typeof regionSchema>;
